import { useContext } from "react";
import { PlayerContext } from "../../PlayerContext";
import FadeInPanel from "./FadeInPanel";

const CLOSE_BUTTON_RESERVE = 56;

const DialogContainer = ({children, closeButton, fadeIn, animationKey = "dialog", ...props})=>{
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier");
    const fromDemo = useContext(PlayerContext).get("fromDemo");
    const idPrefix = fromDemo ? (fromDemo +"-") : "";
    const hasCloseButton = closeButton != null;
    const closeReserve = hasCloseButton ? CLOSE_BUTTON_RESERVE * sizeMultiplier : 0;
    const availableHeight = storyDimensions.containerHeight - closeReserve;
    const horizontalInset = 16 * sizeMultiplier;
    const panelWidth = storyDimensions.containerWidth - horizontalInset * 2;

    if (props.opened){
        const dialogBody = (
            <div
                id={idPrefix + "dialog-background"}
                name={idPrefix + "dialog-background"}
                style={{
                    position: "absolute",
                    zIndex: 20,
                    width: storyDimensions.containerWidth,
                    height: storyDimensions.containerHeight,
                    background: "#FFFFFFB0",
                    display: hasCloseButton ? "block" : "flex",
                    flexDirection: hasCloseButton ? undefined : "row",
                    justifyContent: hasCloseButton ? undefined : "center",
                    alignItems: hasCloseButton ? undefined : "center",
                    overflow: "hidden",
                    ...props.style,
                }}
                onClick={(e)=>{if (e.target.id == idPrefix+"dialog-background") props.onClose();}}
            >
                <div
                    style={hasCloseButton ? {
                        position: 'absolute',
                        top: availableHeight / 2,
                        left: horizontalInset,
                        width: panelWidth,
                        transform: 'translateY(-50%)',
                        backgroundColor: 'white',
                        borderRadius: 8 * sizeMultiplier,
                        maxHeight: availableHeight,
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                    } : {
                        backgroundColor: 'white',
                        borderRadius: 8 * sizeMultiplier,
                    }}
                    onClick={(e)=>e.stopPropagation()}
                >
                    {children}
                </div>
                {hasCloseButton && (
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'absolute',
                            bottom: 16 * sizeMultiplier,
                            left: 0,
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 40,
                        }}
                    >
                        {closeButton}
                    </div>
                )}
            </div>
        );

        if (fadeIn) {
            return (
                <FadeInPanel
                    className="dialog-container-fade"
                    animationKey={animationKey}
                    style={{
                        position: "absolute",
                        zIndex: 20,
                        width: storyDimensions.containerWidth,
                        height: storyDimensions.containerHeight,
                        pointerEvents: "auto",
                    }}
                >
                    {dialogBody}
                </FadeInPanel>
            );
        }

        return dialogBody;
    }
    else return null;
}

export default DialogContainer;
